module.exports = __webpack_public_path__ + "img/icon-dissatisfied.2059899.svg";